import React from 'react';
import PropTypes from 'prop-types';
import { getSmartImage } from '../../helpers/helpers';

function CircleThumbnail({ src }) {
  return src ? (
    <img className='circle-thumbnail' src={getSmartImage(src)} alt='' />
  ) : (
    <span className='circle-thumbnail circle-thumbnail-placeholder' role='img' aria-label='No Circle cover image'>
      <svg viewBox='0 0 24 24' width='28' height='28' fill='none' opacity='0.75' aria-hidden='true'>
        <circle cx='9' cy='12' r='6' stroke='currentColor' strokeWidth='0.5' />
        <circle cx='15' cy='12' r='6' stroke='currentColor' strokeWidth='0.5' />
      </svg>
    </span>
  );
}

CircleThumbnail.propTypes = { src: PropTypes.string };

export default CircleThumbnail;
